import React from "react";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import ConnectedCategories from "./ConnectedCategories";
import ConnectedSimpleCategory from "./ConnectedSimpleCategory";

const DetectCategoryUi = ({ categorySystemType, controlId }) => {
    const {
        ENUMS: {
            CategorySetting: { SINGLE_CATEGORY, MULTI_CATEGORY },
        },
    } = constants;
    const detectUi = () => {
        switch (categorySystemType) {
            case MULTI_CATEGORY: {
                return <ConnectedCategories controlId={controlId} />;
            }
            case SINGLE_CATEGORY:
            default: {
                return <ConnectedSimpleCategory controlId={controlId} />;
            }
        }
    };
    return <>{detectUi()}</>;
};

DetectCategoryUi.propTypes = {
    // Setting enum that maps to a key from ENUMS.CategorySetting
    categorySystemType: PropTypes.number.isRequired,
    // Control id to pass down to connected components
    controlId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
};

export default DetectCategoryUi;
